// extracted by mini-css-extract-plugin
export default {"content":"DarkComponent_content__lImyp"};